module.exports = __webpack_public_path__ + "img/search.69f8c498.svg";